import React from "react"

import { MDBContainer, MDBRow, MDBCol } from "mdbreact"

const ImageLeft = ({ content = "content", title = "title" }) => {
  return (
    <section className="py-md-5 my-md-5">
      <MDBContainer>
        <MDBRow>
          <MDBCol>
            <MDBRow>
              <MDBCol
                size="12"
                md="5"
                className="mb-5 mb-md-0 text-center text-md-left"
              >
                <img
                  src="https://placehold.it/400x250?text=Image 400x250"
                  alt="left"
                  className="img-fluid"
                />
              </MDBCol>
              <MDBCol
                size="12"
                md="7"
                className="text-center text-md-left"
                middle
              >
                <h2 className="font-weight-bold pb-5 pb-md-3 h2-responsive">
                  {title}
                </h2>
                <p className="grey-text ">{content}</p>
              </MDBCol>
            </MDBRow>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </section>
  )
}
export default ImageLeft
